import React from 'react';
/* ⛔ `/view`, NOT the root barrel: the root re-exports building helpers that reach for a query client. */
import { EntityIcon, type EntityIconSize } from '@hqo/entity-icon/view';
import { initialsOf } from 'utils/initials';

interface AddOnPartyIconProps {
  name: string;
  logoUrl?: string;
  /* `sm` (32px) beside a section name; `md` (40px) where the vendor is the screen's heading. */
  size?: EntityIconSize;
}

/**
 * VIS-2193. The vendor mark beside a party's name on the add-on step and dialog: the logo helix
 * resolved (helix#11201, already a full url), or the party's initials. The same disc the booking's
 * own add-ons card draws. Decorative: the name always sits beside it, so its alt is empty.
 */
export const AddOnPartyIcon = ({ name, logoUrl, size = 'sm' }: AddOnPartyIconProps): JSX.Element => (
  <span className="shrink-0" data-testid="add-on-party-icon">
    <EntityIcon
      key={logoUrl ?? 'no-logo'}
      imageUrl={logoUrl}
      fallback={<span className="text-xs font-semibold">{initialsOf(name)}</span>}
      size={size}
      shape="circle"
      alt=""
    />
  </span>
);
